import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { processorNamesConstant } from '../../../core/routing/constants/processor-names.constant';
import { DomSanitizer } from '@angular/platform-browser';
import { CreateSKUIdContentResponse, SKUCompare, SkuIdInfoConfiguration, SKUIdInfoViewModal } from '../../../core/routing/services/sku-ids/sku-id-info.i';
import { SkuIdInfoService } from '../../../../app/core/routing/services/sku-ids/sku-id-info.service';
import { AppGlobal } from '../../../core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { IPOSValidator } from '../../../../app/common/validators/validators';
import { DataService } from '../../../../app/core/data/data-service';
import { CommonService } from '../../../../app/common/services/common.service';
import { osNameConstant } from '../../../../app/core/routing/constants/os-names.constant';
import { graphicsModelsConstant } from '../../../../app/core/routing/constants/graphics-models.constant';
import { CreateProfileService } from '../../../../app/core/routing/services/profile/create-profile.service';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-create-sku-id-info',
  templateUrl: './create-sku-id-info.component.html',
  styleUrls: ['./create-sku-id-info.component.scss']
})
export class CreateSkuIdInfoComponent implements OnInit, OnDestroy {
  @Output() readonly gobackToSkuIdInfoParent = new EventEmitter<object>();
  @ViewChild('createSKUPage') createSKUPage: ElementRef;
  skuIdInfoForm: FormGroup;
  selectedSegmentId: any;
  selectedMainTileId: any;
  selectedPromoId1: any;
  selectedPromoId2: any;
  selectedPromoId3: any;
  uploadImageSelected;
  uploadViaURLSelected;
  segmentList = [];
  customMainTileList = [];
  promoContentList = [];
  processorList = [];
  customFieldArray = [];
  selectedProcessorList = [];
  osList = [];
  graphicsModelList = [];
  newInput: any = {};
  disableAdd: boolean;
  isPriceSupress: boolean;
  searchByNamePlaceholderText = GlobalConstants.SKU_SEARCH_BY_NAME;
  selectGraphicsModels = GlobalConstants.SELECT_GRAPHICS_MODELS;
  selectOperatingSystem = GlobalConstants.SELECT_OPERATING_SYSTEM;
  suppressAdd: boolean;
  notFoundText = GlobalConstants.NO_DATA_FOUND;
  skuCodeText = GlobalConstants.SKU_CODE;
  internalNameText = GlobalConstants.INTERNAL_NAME;
  batteryLifeText = GlobalConstants.BATTERY_LIFE;
  batteryLifePlaceholderText = GlobalConstants.SKU_BATTERY_LIFE_PLACEHOLDER_TEXT;
  primaryPricePlaceholderText = GlobalConstants.SKU_PRIMARY_PRICE_PLACEHOLDER_TEXT;
  secondaryPricePlaceholderText = GlobalConstants.SKU_SECONDARY_PRICE_PLACEHOLDER_TEXT;
  segmentLabelText = GlobalConstants.SEGMENT_TEXT;
  enterNamePlaceholderText = GlobalConstants.SKU_ENTER_NAME_PLACEHOLDER_TEXT;
  enterValuePlaceholderText = GlobalConstants.SKU_ENTER_VALUE_PLACEHOLDER_TEXT;
  dasTeteLabel = GlobalConstants.DAS_TETE_COL_NAME;
  dasTroncLabel = GlobalConstants.DAS_TRONC_COL_NAME;
  dasMembreLabel = GlobalConstants.DAS_MEMBRE_COL_NAME;
  deviceNameLabel = GlobalConstants.DEVICE_NAME;
  uploadImageTootliptext = GlobalConstants.SKU_INFO_UPLOAD_IMAGE_TOOLTIP;
  imageURLPlaceholderText = GlobalConstants.SKU_UPLOAD_IMAGE_URL_PLACEHOLDER_TEXT;
  memoryLabel = GlobalConstants.MEMORY_WITHOUT_OPTANE;
  storageLabel = GlobalConstants.STORAGE;
  cancelLabel = GlobalConstants.CANCEL;
  saveChangesLabel = GlobalConstants.SAVE_AND_PROCEED;
  ramPlaceholderText = GlobalConstants.SKU_RAM_PLACEHOLDER_TEXT;
  osPlaceholderText = GlobalConstants.SKU_OS_PLACEHOLDER_TEXT;
  graphicsPlaceholderText = GlobalConstants.SKU_GRAPHICS_PLACEHOLDER_TEXT;
  storagePlaceholderText = GlobalConstants.SKU_STORAGE_PLACEHOLDER_TEXT;
  primaryColor: string;
  secondaryColor: string;
  priceBackgroundColor: string;
  isPriceStrikethrough: string;
  imgDoc: any;
  imgFileName: string;
  imgFileSize: number;
  imgFileType: string;
  imgUrl: any = '';
  imgSizeError: boolean;
  imgTypeError: any;
  isImgAvailable = false;
  isImgFormat: boolean;
  processorVal: string;
  osVal: string;
  graphicsVal: string;
  errorMessage: string;
  isSKUCodeExists = false;
  customFieldList = new Map();
  nameCustomFieldList = new Map();
  valueCustomFieldList = new Map();
  nameCFArrayList = [];
  valueCFArrayList = [];
  isNameInputEmpty = true;
  isNameIndexInputEmpty = true;
  nameInputCusField: string = '';
  valueInputCusField: string = '';
  userRole: string;
  retailerConfig: any;
  isRepairabilityIndexEnabled = false;
  dasMembre: string;
  dasTete: string;
  dasTronc: string;
  isCustomTileEnabled = false;
  isAllowPriceSuppressionEnabled = false;
  isPriceStrikethroughDisabled = true;
  isCusFieldLabelsVisible = false;
  selectedSKUIdContent: SKUIdInfoViewModal;
  selectedSKUIdContentId: string;
  processorItem: any;
  osItem: any;
  graphicsItem: any;
  processorListText = GlobalConstants.PROCESSOR_LIST_SELECT_TEXT;
  isImgVideoSizeInfoEnabled: boolean;
  isRemoveEnabled: boolean;
  isCompareSectionExpanded = false;
  userId: string = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private appGlobal: AppGlobal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private createProfileService: CreateProfileService,
    private formBuilder: FormBuilder,
    private skuIdService: SkuIdInfoService,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.isImgVideoSizeInfoEnabled = this.commonService.isSizeContraintsEnabled;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.getRetailerConfig();
          this.isRepairabilityIndexEnabled = this.retailerConfig?.isRepairabilityIndexEnabled ? this.retailerConfig?.isRepairabilityIndexEnabled : false;
          this.isCustomTileEnabled = this.retailerConfig?.customSrtEnabled ? this.retailerConfig?.customSrtEnabled : false;
          this.isPriceSupress = this.retailerConfig?.isPriceSupress ? this.retailerConfig?.isPriceSupress : false;
          this.isRemoveEnabled = this.retailerConfig?.removeEnabled ? this.retailerConfig?.removeEnabled : false;
        }
      });
    this.selectedSegmentId = null;
    this.selectedMainTileId = null;
    this.selectedPromoId1 = null;
    this.selectedPromoId2 = null;
    this.selectedPromoId3 = null;
    this.segmentList = this.skuIdService.segmentContentList.sort((a, b) => b.updatedTime - a.updatedTime);
    this.customMainTileList = this.skuIdService.mainTileContentList.sort((a, b) => b.updatedTime - a.updatedTime);
    this.promoContentList = this.skuIdService.promoContentList.sort((a, b) => b.updatedTime - a.updatedTime);
    this.dataService.getSKUIDContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((skuIDContentToEdit: any) => {
        if (skuIDContentToEdit) {
          this.selectedSKUIdContent = skuIDContentToEdit;
          this.selectedSKUIdContentId = this.selectedSKUIdContent.skuID;
          this.isPriceStrikethroughDisabled = (this.selectedSKUIdContent?.skuList?.secondaryPrice !== '') ? false : true;
          this.selectedSegmentId = this.checkAssetLibraryContents(this.selectedSKUIdContent?.skuList?.segmentID, 'Segment') || null;
          this.selectedMainTileId = this.checkAssetLibraryContents(this.selectedSKUIdContent?.skuList?.customHeroTile, 'Main Tile') || null;
          this.selectedPromoId1 = this.checkAssetLibraryContents(this.selectedSKUIdContent?.skuList?.promotionalContentIDs[0], 'Promo1') || null;
          this.selectedPromoId2 = this.checkAssetLibraryContents(this.selectedSKUIdContent?.skuList?.promotionalContentIDs[1], 'Promo2') || null;
          this.selectedPromoId3 = this.checkAssetLibraryContents(this.selectedSKUIdContent?.skuList?.promotionalContentIDs[2], 'Promo3') || null;
          this.processorVal = this.selectedSKUIdContent?.skuList?.compare?.processor;
          this.osVal = this.selectedSKUIdContent?.skuList?.compare?.operatingSystem;
          this.graphicsVal = this.selectedSKUIdContent?.skuList?.compare?.graphicsCard;
          this.imgFileName = this.selectedSKUIdContent?.skuList?.compare?.uploadImageURL || '';
          this.processorList = processorNamesConstant;
          this.graphicsModelList = graphicsModelsConstant;
          this.osList = osNameConstant.sort((a, b) => a.name.localeCompare(b.name));
          this.processorItem = this.getTranslatedData(this.selectedSKUIdContent?.skuList?.compare?.processor, this.processorList);
          this.osItem = this.getTranslatedData(this.selectedSKUIdContent?.skuList?.compare?.operatingSystem, this.osList);
          this.graphicsItem = this.getTranslatedData(this.selectedSKUIdContent?.skuList?.compare?.graphicsCard, this.graphicsModelList);
          this.isCompareSectionExpanded = this.setCompareSectionAccordian(this.selectedSKUIdContent);
        }
      });
    this.createSkuIdInfoForm();
    this.isPriceStrikethrough = (this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.priceStrikethrough : "F";
    this.suppressAdd = (this.selectedSKUIdContent?.skuList?.compare?.customFields?.length == 5) ? true : false;
    this.processorList = processorNamesConstant;
    this.osList = osNameConstant.sort((a, b) => a.name.localeCompare(b.name));
    this.graphicsModelList = graphicsModelsConstant;
    this.uploadImageSelected = true;
    this.primaryColor = (this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.primaryPriceColour : GlobalConstants.WHITE_COLOR;
    this.secondaryColor = (this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.secondaryPriceColour : GlobalConstants.WHITE_COLOR;
    this.priceBackgroundColor = (this.selectedSKUIdContent && this.selectedSKUIdContent?.skuList?.priceStrikethroughColour !== undefined) ?
      this.selectedSKUIdContent?.skuList?.priceStrikethroughColour : GlobalConstants.STORELOGO_BGCOLOR;
  }
  getTranslatedData(nameToBeTranslated: string, list: any): string {
    const data = list?.find(i => i?.nameInEng === nameToBeTranslated);
    return (data?.name || null);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getRetailerConfig() {
    return new Promise((resolve, reject) => {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const config = JSON.parse(data?.retailer?.configurations);
          resolve(config);
        })
    })
  }

  checkAssetLibraryContents(contentId: string, type: string) {
    let contentID;
    if (type == 'Segment') {
      const segmentIdList = this.segmentList?.filter(
        ele => ele.id === contentId);
      contentID = (segmentIdList.length > 0) ? segmentIdList[0].id : null;
    } else if (type === 'Main Tile') {
      const mainTileIdList = this.customMainTileList?.filter(
        ele => ele.id === contentId);
      contentID = (mainTileIdList.length > 0) ? mainTileIdList[0].id : null;
    } else if (type === 'Promo1') {
      const promo1IdList = this.promoContentList?.filter(
        ele => ele.id === contentId);
      contentID = (promo1IdList.length > 0) ? promo1IdList[0].id : null;
    } else if (type === 'Promo2') {
      const promo2IdList = this.promoContentList?.filter(
        ele => ele.id === contentId);
      contentID = (promo2IdList.length > 0) ? promo2IdList[0].id : null;
    } else if (type === 'Promo3') {
      const promo3IdList = this.promoContentList?.filter(
        ele => ele.id === contentId);
      contentID = (promo3IdList.length > 0) ? promo3IdList[0].id : null;
    }
    return contentID;
  }

  createSkuIdInfoForm() {
    this.skuIdInfoForm = this.formBuilder.group({
      skuCode: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent.publishedName : ''),
      internalName: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent.internalName : ''),
      batteryLife: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.batteryLife : ''),
      primaryPrice: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.primaryPrice : ''),
      secondaryPrice: new FormControl({ value: (this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.secondaryPrice : '', disabled: (this.selectedSKUIdContent && this.selectedSKUIdContent?.skuList?.primaryPrice !== '') ? false : true }),
      repairabilityIndexVal: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.repairabilityIndex : ''),
      dasTeteValue: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.das_tete : ''),
      dasTroncValue: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.das_tronc : ''),
      dasMembreValue: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.das_membre : ''),
      deviceName: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.compare?.deviceName : ''),
      procSelect: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.compare?.processor || GlobalConstants.PROCESSOR_LIST_SELECT_TEXT : GlobalConstants.PROCESSOR_LIST_SELECT_TEXT),
      compareImageUrl: new FormControl(''),
      memoryValue: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.compare?.memory : ''),
      storageValue: new FormControl((this.selectedSKUIdContent) ? this.selectedSKUIdContent?.skuList?.compare?.storage : ''),
      customFields: (this.selectedSKUIdContentId) ? this.getCustomFieldsFormData() : this.formBuilder.array([])
    });
  }

  getCustomFieldsFormData() {
    const customFieldsArray = [];
    if (this.selectedSKUIdContent?.skuList?.compare?.customFields?.length > 0) {
      const cFArray = this.selectedSKUIdContent?.skuList?.compare?.customFields;
      if (cFArray.length > 0) this.isCusFieldLabelsVisible = true;
      for (let i = 0; i < cFArray.length; i++) {
        const keys = Object.keys(cFArray[i]);
        const values = Object.values(cFArray[i]);
        this.nameCustomFieldList.set(i, keys[0]);
        this.nameCFArrayList.push(keys[0]);
        this.valueCustomFieldList.set(i, values[0]);
        this.valueCFArrayList.push(values[0]);
        customFieldsArray.push(this.formBuilder.group({
          name: new FormControl(keys[0], Validators.required),
          value: new FormControl({ value: values[0], disabled: (keys[0] !== '') ? false : true })
        }));
      }
    }
    return this.formBuilder.array(customFieldsArray);
  }

  setCompareSectionAccordian(data) {
    let isAccExpand: boolean;
    if (data.skuList.compare.deviceName === '' && this.imgFileName === ''
      && data.skuList.compare.processor === '' && data.skuList.compare.memory === ''
      && data.skuList.compare.operatingSystem === '' && data.skuList.compare.graphicsCard === ''
      && data.skuList.compare.storage === '' && data.skuList.compare.customFields.length == 0) {
      isAccExpand = false;
    } else isAccExpand = true;
    return isAccExpand;
  }

  onInputClicked() {
    this.isSKUCodeExists = false;
  }

  changeColorPicker(value: string, type) {
    if (type === 'primary') {
      this.primaryColor = value;
    } else if (type === 'secondary') {
      this.secondaryColor = value;
    } else if (type === 'backgroundColor') {
      this.priceBackgroundColor = value;
    }
  }

  patternToAllowOnNumbers(event) {
    const PAT_BATTERYLIFE = IPOSValidator.BATTERYLIFE_REGEX;
    if (PAT_BATTERYLIFE.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  togglePriceStrikethrough(event) {
    if (event.target.checked) {
      this.isPriceStrikethrough = "T";
    } else {
      this.isPriceStrikethrough = "F";
    }
  }

  onProcessorSelection(selectedValue) {
    this.processorVal = (selectedValue != undefined) ? selectedValue.nameInEng : '';
  }

  onOsSelection(selectedValue) {
    this.osVal = (selectedValue != undefined) ? selectedValue.nameInEng : '';
  }

  onGraphicsSelection(selectedValue) {
    this.graphicsVal = (selectedValue != undefined) ? selectedValue.nameInEng : '';
  }

  getPriceValue() {
    if (this.skuIdInfoForm.controls.primaryPrice.value === '' && this.skuIdInfoForm.controls.secondaryPrice.value === '') {
      this.skuIdInfoForm.controls.secondaryPrice.disable();
      this.isPriceStrikethroughDisabled = true;
    } else if (this.skuIdInfoForm.controls.primaryPrice.value === '' && this.skuIdInfoForm.controls.secondaryPrice.value !== '') {
      this.skuIdInfoForm.controls.secondaryPrice.disable();
      this.isPriceStrikethroughDisabled = true;
    } else if (this.skuIdInfoForm.controls.primaryPrice.value !== '' && this.skuIdInfoForm.controls.secondaryPrice.value === '') {
      this.skuIdInfoForm.controls.secondaryPrice.enable();
      this.isPriceStrikethroughDisabled = true;
    } else {
      this.skuIdInfoForm.controls.secondaryPrice.enable();
      this.isPriceStrikethroughDisabled = false;
    }
  }

  getSecondaryPriceValue() {
    if (this.skuIdInfoForm.controls.secondaryPrice.value === '') this.isPriceStrikethroughDisabled = true;
    else this.isPriceStrikethroughDisabled = false;
  }

  getDetailsComparisonInfo() {
    this.isCompareSectionExpanded = !this.isCompareSectionExpanded;
  }

  uploadImage(data) {
    this.imgDoc = data.files;
    if (this.imgDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(this.imgDoc[0]);
      this.imgFileName = this.imgDoc[0].name;
      this.imgFileType = this.imgDoc[0].type;
      this.imgFileSize = this.imgDoc[0].size;
      const fileType = this.imgDoc[0].type.split('/')[1];

      if (this.imgFileName && fileType === GlobalConstants.CONTENT_TYPE_JPEG) {
        this.imgFileName = this.imgFileName.substring(0, this.imgFileName.lastIndexOf('.')) + "." + GlobalConstants.CONTENT_TYPE_JPEG;
      }
      if (this.imgFileType.indexOf(GlobalConstants.FILE_TYPE_IMAGE) > -1) {
        this.imgSizeError = this.imgFileSize > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
        if (fileType === GlobalConstants.CONTENT_TYPE_PNG ||
          fileType === GlobalConstants.CONTENT_TYPE_GIF ||
          fileType === GlobalConstants.CONTENT_TYPE_JPEG) {
          this.imgTypeError = false;
          if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
            this.imgSizeError = false;
          }
        } else { this.imgTypeError = true; }
        this.isImgAvailable = !(this.imgSizeError || this.imgTypeError || (this.imgSizeError && this.imgTypeError));
        this.isImgFormat = true;
        this.imgUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.imgDoc[0]));
      } else {
        this.imgTypeError = true;
        this.isImgFormat = false;
      }

      if (this.imgSizeError || this.imgTypeError) {
        this.imgUrl = '';
      } else {
        reader.onload = _event => {
          this.imgUrl = reader.result;
        };
      }
    }
  }

  getSelectedSegment(segmentData) {
    this.selectedSegmentId = segmentData ? segmentData?.id : null;
  }

  getSelectedMainTile(mainTileData) {
    this.selectedMainTileId = mainTileData ? mainTileData?.id : null;
  }

  getSelectedPromo(promoData, type) {
    if (type === 'promo1') {
      this.selectedPromoId1 = promoData ? promoData?.id : null;
    }
    else if (type === 'promo2') {
      this.selectedPromoId2 = promoData ? promoData?.id : null;
    }
    else if (type === 'promo3') {
      this.selectedPromoId3 = promoData ? promoData?.id : null;
    }
  }

  setNameCustomFieldInfo(index, data) {
    if (this.skuIdInfoForm.controls.customFields["controls"][index].controls.name.value !== '') this.skuIdInfoForm.controls.customFields["controls"][index].controls.value.enable();
    else this.skuIdInfoForm.controls.customFields["controls"][index].controls.value.disable();
    this.nameCustomFieldList.set(index, data);
    let indexExists = false;
    if (this.nameCFArrayList.length > 0) {
      this.nameCFArrayList.forEach((a, i) => {
        if (i == index) {
          this.nameCFArrayList[i] = data;
          indexExists = true;
        }
      });
    }
    if (!indexExists) this.nameCFArrayList.push(data);
  }

  setValueCustomFieldInfo(index, data) {
    this.valueCustomFieldList.set(index, data);
    let indexExists = false;
    if (this.valueCFArrayList.length > 0) {
      this.valueCFArrayList.forEach((a, i) => {
        if (i == index) {
          this.valueCFArrayList[i] = data;
          indexExists = true;
        }
      });
    }
    if (!indexExists) this.valueCFArrayList.push(data);
  }

  addCustomFields() {
    this.setIndexForValue();
    if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length == 0) this.isCusFieldLabelsVisible = true;
    if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length < 5) {
      const customFields = this.skuIdInfoForm?.controls?.customFields as FormArray;
      customFields.push(this.formBuilder.group({
        name: new FormControl('', Validators.required),
        value: new FormControl({ value: '', disabled: true })
      }));
      if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length == 5) this.suppressAdd = true;
    }
  }

  removeCustomFields(index) {
    this.suppressAdd = false;
    (<FormArray>this.skuIdInfoForm.controls.customFields).removeAt(index);
    this.nameCFArrayList.splice(index, 1);
    this.valueCFArrayList.splice(index, 1);
    if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length == 0) this.isCusFieldLabelsVisible = false;
  }

  setIndexForValue() {
    if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length > 0) {
      const indexVal = this.skuIdInfoForm?.controls?.customFields["controls"]?.length - 1;
      if (this.valueCustomFieldList.size == 0) this.setValueCustomFieldInfo(0, '');
      else {
        let valueList = Array.from(this.valueCustomFieldList.values());
        if (valueList[indexVal] === undefined) this.setValueCustomFieldInfo(indexVal, '');
      }
    }
  }

  cancelChanges() {
    this.gobackToSkuIdInfoParent.emit({ cancel: true });
  }

  getCustomFields() {
    let cfMap = new Map();
    let customFieldsEntries = [];
    let keyList = this.nameCFArrayList;
    let valueList = this.valueCFArrayList;
    for (let i = 0; i < keyList.length; i++) {
      if (valueList[i] == undefined) cfMap.set(keyList[i], '');
      else cfMap.set(keyList[i], valueList[i]);
    }
    const obj = {};
    cfMap.forEach((value, key) => {
      obj[key] = value;
    });
    customFieldsEntries = this.convertObjToArr(obj);
    return customFieldsEntries;
  }

  convertObjToArr(obj) {
    let result = [];
    for (let key in obj) {
      result.push({ [key]: obj[key] });
    }
    return result;
  }

  getSelectedPromoIdsList() {
    this.selectedProcessorList = [];
    this.selectedProcessorList.push(this.selectedPromoId1 || '');
    this.selectedProcessorList.push(this.selectedPromoId2 || '');
    this.selectedProcessorList.push(this.selectedPromoId3 || '');
    this.selectedProcessorList = (this.selectedPromoId1 == null && this.selectedPromoId2 == null && this.selectedPromoId3 == null) ? this.selectedProcessorList.filter(item => item) : this.selectedProcessorList;
    return this.selectedProcessorList;
  }

  checkValidationExitsForCustomFields() {
    let isErrorExists = false;
    const cFields = this.skuIdInfoForm?.controls?.customFields["controls"];
    if (cFields.length > 0) {
      for (let item of cFields) {
        if (!item.valid && item.controls.name.errors?.required || item.controls.name.value.match(GlobalConstants.QUOTES_MATCH_REGEX)) {
          isErrorExists = true;
        }
      }
    }
    return isErrorExists;
  }

  checkQuotes(txt) {
    if (txt) {
      return txt.match(GlobalConstants.QUOTES_MATCH_REGEX);
    }
  }
  onSaveChanges() {
    if (this.skuIdInfoForm?.controls?.customFields["controls"]?.length == 5) this.setIndexForValue();
    const validationExists = this.checkValidationExitsForCustomFields();
    if (!validationExists) {
      if (this.selectedSKUIdContentId) this.updateSKUContent();
      else this.createSKUContent();
    }
  }

  prepareSKUComparisionPayload() {
    const skuCompare: SKUCompare = {
      deviceName: this.skuIdInfoForm.controls.deviceName.value || '',
      imageURL: this.skuIdInfoForm.controls.compareImageUrl.value,
      uploadImageURL: this.imgFileName || '',
      processor: this.processorVal || '',
      memory: this.skuIdInfoForm.controls.memoryValue.value || '',
      operatingSystem: this.osVal || '',
      graphicsCard: this.graphicsVal || '',
      storage: this.skuIdInfoForm.controls.storageValue.value || '',
      customFields: this.getCustomFields()
    }
    return skuCompare;
  }

  preparePayload() {
    if (this.skuIdInfoForm.controls.primaryPrice.value === '') {
      this.skuIdInfoForm.controls.secondaryPrice.setValue('');
      this.isPriceStrikethrough = "F";
    }
    if (this.skuIdInfoForm.controls.secondaryPrice.value === '') {
      this.isPriceStrikethrough = "F";
    }
    const skuIdInfo: SkuIdInfoConfiguration = {
      skuCode: this.skuIdInfoForm.controls.skuCode.value.trim(),
      batteryLife: this.skuIdInfoForm.controls.batteryLife.value,
      primaryPrice: this.skuIdInfoForm.controls.primaryPrice.value,
      secondaryPrice: this.skuIdInfoForm.controls.secondaryPrice.value,
      primaryPriceColour: this.primaryColor,
      secondaryPriceColour: this.secondaryColor,
      priceStrikethrough: this.isPriceStrikethrough,
      priceStrikethroughColour: this.priceBackgroundColor,
      segmentID: this.selectedSegmentId !== null ? this.selectedSegmentId : '',
      customHeroTile: this.selectedMainTileId !== null ? this.selectedMainTileId : '',
      repairabilityIndex: this.skuIdInfoForm.controls.repairabilityIndexVal.value,
      das_tete: this.skuIdInfoForm.controls.dasTeteValue.value,
      das_tronc: this.skuIdInfoForm.controls.dasTroncValue.value,
      das_membre: this.skuIdInfoForm.controls.dasMembreValue.value,
      promotionalContentIDs: this.getSelectedPromoIdsList(),
      compare: this.prepareSKUComparisionPayload()
    };
    return skuIdInfo;
  }

  displayCustomErrorMessage(error) {
    if (error.responseContext.exceptionResponse.errorDetails === GlobalConstants.SKUCODE_UNIQUE_API_ERROR_DESC) {
      setTimeout(_ => {
        this.createSKUPage.nativeElement.scrollIntoView();
      }, 0);
      this.isSKUCodeExists = true;
      this.errorMessage = GlobalConstants.SKU_CODE_UNIQUE_ERROR_MSG;
    }
  }

  createSKUContent() {
    const payloadToAdd = this.preparePayload();
    const internalName = this.skuIdInfoForm.controls.internalName.value;
    this.skuIdService.createSKUIdContent(JSON.stringify(payloadToAdd), internalName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createSKUIdContentResponse => {
        this.googleAnalyticsService.newModelSkuInfoAdded(payloadToAdd.skuCode);
        if (this.imgDoc !== undefined) await this.uploadImageToS3(createSKUIdContentResponse);
        const createSKUIdContentResponseObj: CreateSKUIdContentResponse = createSKUIdContentResponse as CreateSKUIdContentResponse;
        this.gobackToSkuIdInfoParent.emit(createSKUIdContentResponseObj);
      },
        error => {
          this.displayCustomErrorMessage(error);
        });
  }

  updateSKUContent() {
    this.googleAnalyticsService.skuInfoEdited();
    const payloadToEdit = this.preparePayload();
    const internalName = this.skuIdInfoForm.controls.internalName.value;
    this.skuIdService.updateSKUIdContent(JSON.stringify(payloadToEdit), internalName, this.selectedSKUIdContentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async editSKUIdContentResponse => {
        if (this.imgDoc !== undefined) await this.uploadImageToS3(editSKUIdContentResponse);
        const editSKUIdContentResponseObj: CreateSKUIdContentResponse = editSKUIdContentResponse as CreateSKUIdContentResponse;
        this.gobackToSkuIdInfoParent.emit(editSKUIdContentResponseObj);
      },
        error => {
          this.displayCustomErrorMessage(error);
        });
  }

  uploadImageToS3(resData) {
    return new Promise((resolve, reject) => {
      let imgFile = this.imgDoc[0];
      let imgFileType = this.imgDoc[0].type.split('/')[1];
      let folderName = GlobalConstants.SKU_COMPARE_IMG_S3_FOLDER;
      this.skuIdService.uploadImageToS3(resData.skuContent.skuID, imgFile, imgFileType, folderName)
        .subscribe(res => {
          resolve(res);
        });
    })
  }
  getRepairabilityIndex(event: any) {
    const charCode = event.which || event.keyCode;
    const zero = String.fromCharCode(48);
    const one = String.fromCharCode(49);
    if (event.srcElement.value[0] === undefined) {
      if ((charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
    if (event.srcElement.value[1] === undefined) {
      if (event.srcElement.value[0] === one) {
        if (charCode !== 46 && charCode !== 44 && charCode !== 48) {
          return false;
        }
        return true;
      }
      if (charCode !== 46 && charCode !== 44) {
        return false;
      }
      return true;
    }
    if (event.srcElement.value[2] === undefined) {
      if ((charCode < 48 || charCode > 57)) {
        return false;
      }
      if (event.srcElement.value[1] === zero) {
        return false;
      }
      return true;
    }
  }

  getDASValue(event: any) {
    const charCode = event.which || event.keyCode;
    let value = event.target.value;
    if (charCode === 46) {
      if ((value.indexOf('.') === -1) && (value.length === 0)) {
        return false;
      }
      if ((value.indexOf('.')) === -1 && !value.includes(',')) {
        return true;
      }
      return false;
    }
    if (charCode === 44) {
      if ((value.indexOf(',') === -1) && (value.length === 0)) {
        return false;
      }
      if ((value.indexOf(',')) === -1 && !value.includes('.')) {
        return true;
      }
      return false;
    }
    //restricting user to enter number after 0
    if (value[0] === '0' && value.length === 1) {
      if (charCode === 44 || charCode === 46) {
        return true;
      }
      return false;
    }
    if ((charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateDASFormat(value: any, id: any) {
    if (id === GlobalConstants.DASMEMBRE) {
      this.dasMembre = value;
    }
    else if (id === GlobalConstants.DASTRONC) {
      this.dasTronc = value;
    }
    else if (id === GlobalConstants.DASTETE) {
      this.dasTete = value;
    }
    return value;
  }
}
